import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiV2WorkrecordElFindDateParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiV2WorkrecordElFindDateParams, unknown>

const fetchWorkRecordsByDate = async (params: ApiV2WorkrecordElFindDateParams) => {
  const { data } = await apiClient.v2.apiV2WorkrecordElFindDate(params);
  return checkApiResponse(data);
}

export const v2WorkRecordDateKeys = {
  all: [QUERY_KEY.v2apiV2WorkrecordElFindDate] as const,
  list: (params: ApiV2WorkrecordElFindDateParams) => [...v2WorkRecordDateKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(v2WorkRecordFindDateQueryOptions(params))` */
export const v2WorkRecordFindDateQueryOptions = (params: ApiV2WorkrecordElFindDateParams) => ({
  queryKey: v2WorkRecordDateKeys.list(params),
  queryFn: () => fetchWorkRecordsByDate(params),
  // 날짜별 데이터 — FCM invalidation(타 사용자 변경)과 mutation invalidation(내 변경)이 커버하므로 5분 캐시
  staleTime: 5 * 60 * 1000,
  gcTime: 5 * 60 * 1000,
})

export const useV2WorkRecordFindDateQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: v2WorkRecordDateKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchWorkRecordsByDate(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
